import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SafePipeModule } from 'safe-pipe';
import { ErrorDialog } from './error/error.dialog';
import { SimpleDialog } from './simple/simple.dialog';

export * from './error/error.dialog';
export * from './simple/simple.dialog';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule, SafePipeModule, MatIconModule],
  declarations: [ErrorDialog, SimpleDialog],
  exports: [ErrorDialog, SimpleDialog]
})
export class DialogModule {}
